import { Link } from 'react-router-dom';

const classItems = [
  {
    icon: 'ri-cake-3-line',
    title: 'Cake Decorating Basics',
    description: 'Learn the foundational skills of cake decorating — leveling, frosting, and basic piping techniques. Perfect for beginners ready to create their first masterpiece.',
    duration: '3 Hours',
    level: 'Beginner',
  },
  {
    icon: 'ri-scissors-cut-line',
    title: 'Fondant & Sculpting',
    description: 'Master fondant work, sculpted figures, and decorative elements that take cakes from beautiful to extraordinary. Great for those ready to level up their skills.',
    duration: '4 Hours',
    level: 'Intermediate',
  },
  {
    icon: 'ri-flower-line',
    title: 'Sugar Flowers & Art',
    description: 'Create stunning handcrafted sugar flowers, leaves, and decorative details. Craft roses, peonies, and more using professional techniques.',
    duration: '4 Hours',
    level: 'Intermediate',
  },
  {
    icon: 'ri-star-line',
    title: 'Advanced Design Workshop',
    description: 'Take on complex tiered designs, painted details, and competition-level decorating techniques in this immersive full-day workshop.',
    duration: '6 Hours',
    level: 'Advanced',
  },
];

export default function ClassesSection() {
  return (
    <section id="classes" className="py-20 md:py-28 bg-cream-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-10 bg-gold-500" />
              <span className="text-gold-500 text-xs uppercase tracking-[0.25em] font-sans font-semibold">Classes &amp; Supplies</span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl text-charcoal-800 leading-tight mb-6">
              Learn the Art of<br /><em className="italic text-blush-500">Cake Decorating</em>
            </h2>
            <p className="text-warm-gray text-base leading-[1.9] font-sans font-light mb-8">
              Sweet Celebrations offers cake decorating classes throughout the year, perfect for beginners and experienced bakers alike. Learn from Sherry&apos;s years of professional experience and discover the joy of creating beautiful, custom desserts yourself.
            </p>
            <p className="text-warm-gray text-base leading-[1.9] font-sans font-light mb-8">
              In addition to classes, we carry baking and decorating supplies so you can keep creating at home between sessions.
            </p>
            <Link
              to="/custom-orders"
              className="inline-flex items-center gap-2 bg-gold-500 hover:bg-gold-600 text-white px-8 py-4 rounded-full font-sans font-semibold text-sm tracking-wide whitespace-nowrap transition-all duration-200 hover:scale-105 cursor-pointer"
            >
              Inquire About Classes
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="relative rounded-2xl overflow-hidden h-[400px]">
            <img
              src="https://public.readdy.ai/ai/img_res/aee0e2d24438796085fb0327aa4594ec.jpg"
              alt="Cake decorating classes at Sweet Celebrations"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900/40 to-transparent" />
            <div className="absolute bottom-6 left-6 bg-white/95 rounded-xl px-5 py-3">
              <p className="text-gold-600 text-xs uppercase tracking-widest font-semibold">Classes Available</p>
              <p className="text-charcoal-800 font-serif text-lg">Year-Round in Lubbock</p>
            </div>
          </div>
        </div>

        {/* Class cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {classItems.map((cls) => (
            <div
              key={cls.title}
              className="bg-white rounded-2xl p-6 border border-warm-200 hover:border-blush-300 hover:scale-[1.02] transition-all duration-200"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-blush-100 text-blush-500 mb-4">
                <i className={`${cls.icon} text-lg`} />
              </div>
              <h3 className="font-serif text-lg text-charcoal-800 mb-2">{cls.title}</h3>
              <p className="text-warm-gray text-sm font-sans leading-relaxed mb-4">{cls.description}</p>
              <div className="flex gap-3 flex-wrap">
                <span className="text-xs px-3 py-1 bg-cream-200 text-charcoal-700 rounded-full font-sans font-semibold">{cls.duration}</span>
                <span className="text-xs px-3 py-1 bg-blush-100 text-blush-600 rounded-full font-sans font-semibold">{cls.level}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
